import { channelClient, RequestPolicies } from 'shared/channels';
import type { FilterValues } from 'shared/types/analytics';
import type { ChartFiltersId } from './chartFiltersModel';
import { chartFiltersContract } from './chartFiltersContract';

/** Saved filters of every chart, one entry per chart id. */
export const chartFiltersClient = {
  getSaved(chartId: ChartFiltersId): Promise<FilterValues | undefined> {
    return channelClient.request(chartFiltersContract, 'getSaved', { chartId }, RequestPolicies.read);
  },

  /** Resolves once the filters are stored. */
  save(chartId: ChartFiltersId, filters: FilterValues): Promise<void> {
    return channelClient.request(chartFiltersContract, 'save', { chartId, filters }, RequestPolicies.mutation);
  },
};
